import React, { useEffect, useState } from 'react';
import Modal from '@material-ui/core/Modal';
import { useStyles } from './FreeInferenceMessageModal.styles';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import textLogoWhite from '../../img/textLogo.png';

export default function FreeInferenceMessageModal(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const navigate = useNavigate();
  const [fontStyle, setFontStyle] = useState('TheJamsil');

  useEffect(() => {
    const defaultLanguage = localStorage.getItem('selectedLanguage') || navigator.language.split('-')[0];
    const defaultFont = defaultLanguage === 'ja' ? 'MPlus1' : 'TheJamsil';
    setFontStyle(defaultFont);
  }, []);

  const messageOneArr = t('freeInferenceMessageModal.messeageOne', { returnObjects: true });
  const messageTwoArr = t('freeInferenceMessageModal.messeageTwo', { returnObjects: true });

  return (
    <Modal className={fontStyle} open={!!props.open} onClose={() => props.setOpenFreeInferenceModal(false)}>
      <div className={classes.messageContainer}>
        <img className={classes.sorisoriAIImg} src={textLogoWhite} alt="sorisoriAI" />
        <div className={classes.messageOneContainer}>
          {messageOneArr.map(message => (
            <div className={classes.messageOne}>{message}</div>
          ))}
        </div>
        <div className={classes.messageTwoContainer}>
          {messageTwoArr.map(message => (
            <div className={classes.messageTwo}>{message}</div>
          ))}
        </div>
        <div className={classes.button} onClick={() => navigate('/subscription')}>
          {t('freeInferenceMessageModal.button')}
        </div>
      </div>
    </Modal>
  );
}
